import { User } from '@core/models/user';
import { UserConfig } from '@core/models/user-config';
import { UserPermission } from '@core/models/user-permission';
import { UserModules } from '@core/models/user-modules';
import isObject from 'lodash-es/isObject';
import jwt_decode from 'jwt-decode';

export const getters = {
  token: (state) => state['token'] || '',
  is_auth: (state, getters) => getters['current_user_id'] && getters['user'],

  current_user_id: (state, getters) => {
    try {
      return jwt_decode(getters['token']).sub;
    } catch (e) {
      return null;
    }
  },

  config: (state) => {
    const value = isObject(state['config']) ? state['config'] : {};
    return new UserConfig(value);
  },

  permissions: (state) => {
    const value = isObject(state['permissions']) ? state['permissions'] : {};
    const modulesValue = isObject(state['modules']) ? state['modules'] : {};
    const modules = new UserModules(modulesValue);
    return new UserPermission(value, modules);
  },

  user: (state) => {
    if (isObject(state['user']) && User.isValidObject(state['user'])) {
      return new User(state['user']);
    }
    return null;
  },

  modules: (state) => {
    const value = isObject(state['modules']) ? state['modules'] : {};
    return new UserModules(value);
  }
};
